import React, { Component } from 'react';
import NavigationTabs from '../nav/NavigationTabs';
import { COLORS } from '../../styles/colors';
import { BLOCK_LIBRARY_MESSAGE } from '../../static-content';
import LibraryList from '../LibraryList';
import { paginationLimit } from './../../helpers.js'
/**
 * List
 */
export class List extends Component { // eslint-disable-line react/prefer-stateless-function
  state = {
    dataLoaded: false
  }

  componentDidMount() {
    this.props.fetchList({
      creatorId: (this.props.user.id || localStorage.id),
      limit: paginationLimit.TEN,
      skip: 0
    }).then(() => {
      this.setState({
        ...this.state,
        dataLoaded: true
      })
    });
  }

  componentWillUnmount() {
    this.props.resetBlocks();
  }

  render() {
    const { blocks, blockCats, user, isLoadMoreListing, fetchMoreBlocks, resetBlocks } = this.props;
    return (
      <div>
        <NavigationTabs
          title="Library"
          subtitle="Blocks"
          description={BLOCK_LIBRARY_MESSAGE}
          set="library"
          activeRoute="/library/blocks"
        />
        {this.state.dataLoaded &&
          <div style={{ marginTop: 10, border: '1px solid ' + COLORS.grey }}>
            <LibraryList
              items={Object.values(blocks)}
              categories={blockCats}
              categoryField="categoryId"
              itemType="block"
              user={user}
              creatorTabs={true}
              isLoadMoreListing = {isLoadMoreListing}
              fetchMoreListing = {fetchMoreBlocks}
              resetListing = {resetBlocks}
            />
          </div>
        }
      </div>
    );
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/components/blocks/List.js